<table style=" border-collapse: collapse;width:100%; background: gray; border: 0px; padding: 0px; margin: 0px;"
    mat-table [dataSource]="dataSourceSites" matSort matSortActive="distance" matSortDirection="asc">

    <ng-container matColumnDef="siteName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site</th>
        <td mat-cell *matCellDef="let element"> {{element.siteName}} </td>
    </ng-container>

    <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td mat-cell *matCellDef="let element"> {{element.city}} </td>
    </ng-container>

    <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
        <td mat-cell *matCellDef="let element"> {{element.region}} </td>
    </ng-container>

    <ng-container matColumnDef="distance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Distance</th>
        <td mat-cell *matCellDef="let element"> {{element.distance}} miles  </td>
    </ng-container>

    <ng-container matColumnDef="postalCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Post Code</th>
        <td mat-cell *matCellDef="let element"> {{element.postalCode}}  </td>
    </ng-container>

    <ng-container matColumnDef="dogF">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dog Friendly
        </th>
        <!-- <td mat-cell *matCellDef="let element" style="vertical-align: top; width: 10%;"> {{element.dogF}} </td> -->
        <td mat-cell *matCellDef="let element">
            <img *ngIf="element.dogF" src="assets/images/1.tv/dogF.svg" alt="" width="30" height="30">
            <!-- <mat-checkbox labelPosition="after" name="dogF"
                [checked]="element.dogF">
            </mat-checkbox> -->
        </td>

    </ng-container>

    <!-- <ng-container matColumnDef="siteName2">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let site" style="vertical-align: top; width: 90%;">
            <table style="width: 100%;">
                <tr>
                    <td>
                        <mat-accordion>
                            <mat-expansion-panel [expanded]="step === -1" (opened)="setStep(0, site)" hideToggle>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Opt-In
                                    </mat-panel-title>
                                    <mat-icon>date_range</mat-icon>
                                    <mat-panel-description>
                                        &nbsp;

                                    </mat-panel-description>
                                </mat-expansion-panel-header>

                                <table>
                                    <tr *ngFor="let application of site.applications | keyvalue">
                                        <td>
                                            <div>
                                                Id: {{showId(application.value)}}
                                            </div>

                                        </td>
                                        <td>
                                            <div>
                                                AppId: {{showStatus(application.value)}}
                                            </div>

                                        </td>
                                        <td>
                                            <form [formGroup]="applicationForm">
                                                <mat-form-field class="demo-full-width">
                                                    <mat-select name="status" formControlName="status"
                                                        placeholder="Status"
                                                        (selectionChange)="onApplicationChange($event.value)">
                                                        <mat-option *ngFor="let status of statuses"
                                                            [value]="showStatus(application.value)">
                                                            {{ status }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </form>
                                        </td>
                                        <td>
                                            <mat-checkbox labelPosition="after" name="paymentStatus">
                                                Paid
                                            </mat-checkbox>
                                        </td>
                                    </tr>
                                </table>

                            </mat-expansion-panel>
                        </mat-accordion>
                    </td>
                </tr>
            </table>
        </td>
    </ng-container> -->

    <!-- <ng-container matColumnDef="postalCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element">
            <table>
                <tr>

                    <td>
                        <i style="cursor: pointer; height:inherit; background:transparent; padding: 0px; margin: 0px;"
                            class="fas fa-sign-out-alt fa-2x" (click)="launchDetails(element)"></i>Details
                    </td>

                    <td style="width:100px; background-color: red;">
                        <button (click)="areYouHear(element)">Click</button>
                        <i style="cursor: pointer; height:inherit; background:transparent; padding: 0px; margin: 0px;"
                            class="fas fa-sign-out-alt fa-2x" (click)="areYouHear(element)"></i>Details
                    </td>

                    <td>{{element.postalCode}}</td>
                    <td>
                        <i style="cursor: pointer; height:inherit; background:transparent; padding: 0px; margin: 0px;"
                            class="fas fa-sign-out-alt fa-2x" (click)="launchTables(element)"></i>Tables
                    </td>
                    <td>
                        <i style="cursor: pointer; height:inherit; background:transparent; padding: 0px; margin: 0px;"
                            class="fas fa-sign-out-alt fa-2x" (click)="launchBookings(element)"></i>Bookings
                    </td>
                    <td>
                        <i style="cursor: pointer; height:inherit; background:transparent; padding: 0px; margin: 0px;"
                            class="fas fa-sign-out-alt fa-2x" (click)="launchCategories(element)"></i>Categories
                    </td>
                </tr>
            </table>
        </td>

    </ng-container> -->



    <!-- <ng-container matColumnDef="tables">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tables</th>
        <td></td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="areYouHear(row)"></tr>
</table>

<!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->

<table class="tableFilter">
    <tr>
        <td style="width:10%; background: rgb(120, 122, 120)">
            <!-- <mat-form-field style="width:100px">
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
            </mat-form-field> -->
        </td>

        <td style="width:90%; background: rgb(120, 122, 120)">
            <mat-paginator style="background: transparent" (page)="matTableChange($event)" [pageSize]="itemsPerPage"
                [pageSizeOptions]="[3, 5, 10, 15, 20]">
            </mat-paginator>
        </td>

    </tr>
</table>